import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
    const tagStyle = {
        width: '100%',
        padding: theme.spacing(2),
        fontSize: 20,
        borderRadius: 8,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    return {
        sideSection: {
            display: 'flex',
            width: '100%',
            marginBottom: '20px',
        },
        button: {
            height: 60,
            fontSize: 20,
            textTransform: 'none',
            [theme.breakpoints.down('md')]: {
                height: 50,
                fontSize: 16,
            },
        },
        acceptButton: {
            '&:hover': {
                background: theme.palette.success.dark,
            },
            backgroundColor: theme.palette.success.main,
            color: 'rgb(255, 255, 255)',
        },
        statusOnModeration: {
            ...tagStyle,
            color: '#ff9800',
            backgroundColor: 'rgba(255, 152, 0, 0.08)',
        },
        statusPublished: {
            ...tagStyle,
            color: '#4caf50',
            backgroundColor: 'rgba(76, 175, 80, 0.08)',
        },
        statusBlocked: {
            ...tagStyle,
            color: '#f44336',
            backgroundColor: 'rgba(244, 67, 54, 0.08)',
        },
        statusDraft: {
            ...tagStyle,
            color: 'rgb(213,0,249)',
            backgroundColor: 'rgba(213,0,249, 0.08)',
        },
    };
});
